// removed by extract-text-webpack-plugin
module.exports = {"storyView":"styles__storyView___3US-G","rotate":"styles__rotate___1JMyG","fadein":"styles__fadein___3Z3_h","slideFromRight":"styles__slideFromRight___3HWqO","waves":"styles__waves___1i8xq"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/StoryView/styles.scss
// module id = ./resources/assets/js/components/StoryView/styles.scss
// module chunks = 0